import { render, staticRenderFns } from "./govHome.vue?vue&type=template&id=77992147&scoped=true"
import script from "./govHome.vue?vue&type=script&lang=js"
export * from "./govHome.vue?vue&type=script&lang=js"
import style0 from "./govHome.vue?vue&type=style&index=0&id=77992147&prod&lang=scss"
import style1 from "./govHome.vue?vue&type=style&index=1&id=77992147&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77992147",
  null
  
)

export default component.exports